export default function CTABanner() {
  return (
    <section className="relative overflow-hidden py-16 md:py-24 px-4 sm:px-6">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=vibrant%20colorful%20assortment%20of%20delicious%20food%20dishes%20burgers%20pizza%20rice%20chicken%20top%20view%20flat%20lay%20dark%20moody%20background%20rich%20textures%20appetizing%20professional%20food%20photography%20dramatic%20lighting%20deep%20colors&width=1600&height=700&seq=ctabg01&orientation=landscape"
          alt=""
          aria-hidden="true"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b md:bg-gradient-to-r from-gray-950/95 via-gray-950/85 to-gray-950/60" />
      </div>

      {/* Content */}
      <div className="relative max-w-6xl mx-auto flex flex-col md:flex-row items-start md:items-center gap-10 md:gap-16">

        {/* Left text */}
        <div className="flex-1 flex flex-col gap-5 md:gap-6">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-tight">
            Hungry? <br />
            <span className="text-[#FFCD1A]">There&apos;s a</span><br />
            Sweetplate for that.
          </h2>
          <p className="text-white/70 text-base md:text-lg leading-relaxed max-w-lg">
            Download the app, order your first meal, and start earning crypto rewards from day one. Join thousands already loving Sweetplate.
          </p>
          <div className="flex flex-col gap-3">
            <div className="flex items-center gap-3 flex-wrap">
              {/* <a
                href="https://sweetplate.org"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity cursor-pointer"
              >
                <img
                  src="https://glovoapp.com/_next/static/media/ios-button.33217f86.svg"
                  alt="App Store"
                  className="h-12 md:h-14 w-auto"
                />
              </a> */}
              <a
                href="https://play.google.com/store/apps/details?id=com.sweetplate.user"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:opacity-80 transition-opacity cursor-pointer"
              >
                <img
                  src="https://glovoapp.com/_next/static/media/google-button.4b60c502.svg"
                  alt="Google Play"
                  className="h-12 md:h-14 w-auto"
                />
              </a>
            </div>
            <p className="text-white/40 text-xs flex items-center gap-1.5">
              <i className="ri-download-line" />
              Direct APK also available — no Play Store needed
            </p>
          </div>
        </div>

        {/* Stats cards */}
        <div className="grid grid-cols-3 md:grid-cols-1 gap-3 w-full md:w-64 flex-shrink-0">
          {[
            { icon: 'ri-user-smile-line', label: 'Happy Customers', value: '50K+', bg: 'bg-[#009E81]' },
            { icon: 'ri-copper-coin-line', label: 'SPC Tokens Earned', value: '2M+', bg: 'bg-[#D4970B]' },
            { icon: 'ri-e-bike-2-line', label: 'Active Riders', value: '800+', bg: 'bg-[#FF7B54]' },
          ].map((item) => (
            <div
              key={item.label}
              className="bg-white/10 backdrop-blur-sm border border-white/10 rounded-2xl p-3 md:px-6 md:py-4 flex flex-col md:flex-row items-center md:items-center gap-2 md:gap-4"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-xl ${item.bg} flex-shrink-0`}>
                <i className={`${item.icon} text-white text-base`} />
              </div>
              <div className="text-center md:text-left">
                <p className="text-lg md:text-2xl font-extrabold text-white">{item.value}</p>
                <p className="text-xs text-white/60 leading-tight">{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
